export type BulkOrderJobStatus =
  | "queued"
  | "enqueuing"
  | "processing"
  | "completed"
  | "failed";

export interface BulkOrderJobProgress {
  jobId: string;
  sellerId: number;
  companyId: string;
  privateCompanyId: string;
  fileName: string;
  orderType: string;
  totalCount: number;
  enqueuedCount: number;
  enqueueFailedCount: number;
  processedCount: number;
  failedCount: number;
  status: BulkOrderJobStatus;
  createdAt: number;
  updatedAt: number;
  enqueuePercent: number;
  processPercent: number;
}

export const isBulkOrderEnqueuePhase = (
  progress: BulkOrderJobProgress | null,
): boolean =>
  Boolean(
    progress &&
      progress.enqueuePercent < 100 &&
      progress.status !== "completed" &&
      progress.status !== "failed",
  );

export const getBulkOrderJobPercent = (
  progress: BulkOrderJobProgress | null,
): number => {
  if (!progress) return 0;

  if (isBulkOrderEnqueuePhase(progress)) {
    return Math.min(100, Math.max(0, Math.round(progress.enqueuePercent)));
  }

  if (typeof progress.processPercent === "number") {
    return Math.min(100, Math.max(0, Math.round(progress.processPercent)));
  }

  if (progress.totalCount > 0) {
    return Math.min(
      100,
      Math.round((progress.processedCount / progress.totalCount) * 100),
    );
  }

  if (progress.status === "completed") return 100;

  return 0;
};

export const isBulkOrderJobTerminal = (
  progress: BulkOrderJobProgress | null,
): boolean =>
  progress?.status === "completed" ||
  progress?.status === "failed" ||
  getBulkOrderJobPercent(progress) >= 100;
